export const STATUS_CODE = {
  NOT_FOUND: 404,
};
